import React from 'react';

import { Box, Typography, useTheme } from '@mui/joy';

import Elipsis from '../../../assets/images/Elipsis.svg?react';
import ThrustIcon from '../../../assets/images/ThrustIcon.svg?react';

interface ThurstProps {
  valueTl?: number;
  valueTr?: number;
  valueBl?: number;
  valueBr?: number;
}

const Thurst: React.FC<ThurstProps> = ({ valueTl = 29, valueTr = 40, valueBl = 62, valueBr = 89 }) => {
  const theme = useTheme();

  const thrustTypographyStyle = {
    color: 'primary.offWhite',
    fontFamily: '"Open Sans", sans-serif',
    fontWeight: 400,
    fontSize: '1.15rem'
  };
  const getColor = (value: number): string => {
    if (value < 10) {
      return theme.palette.crew.thrustBlue;
    }
    if (value < 60) {
      return theme.palette.crew.thrustGreen;
    }
    if (value < 75) {
      return theme.palette.crew.thrustYellow;
    }
    if (value < 90) {
      return theme.palette.crew.thrustOrange;
    }
    return theme.palette.crew.thrustRed;
  };

  return (
    <Box className='w-full h-full rounded-2xl'>
      {/* this will be matched to add borders on figma */}
      <Box className='w-full h-full relative'>
        <Typography
          className='absolute top-[25%] left-[25%] -translate-x-1/2 -translate-y-1/2 z-50 flex items-center justify-center'
          sx={thrustTypographyStyle}
        >
          {valueTl}
        </Typography>

        {/* Top Right */}
        <Typography
          className='absolute top-[25%] left-[75%] -translate-x-1/2 -translate-y-1/2 z-50 flex items-center justify-center'
          sx={thrustTypographyStyle}
        >
          {valueTr}
        </Typography>

        {/* Bottom Left */}
        <Typography
          className='absolute top-[75%] left-[25%] -translate-x-1/2 -translate-y-1/2 z-50 flex items-center justify-center'
          sx={thrustTypographyStyle}
        >
          {valueBl}
        </Typography>

        {/* Bottom Right */}
        <Typography
          className='absolute top-[75%] left-[75%] -translate-x-1/2 -translate-y-1/2 z-50 flex items-center justify-center'
          sx={thrustTypographyStyle}
        >
          {valueBr}
        </Typography>
        <ThrustIcon className='absolute left-[39%] sm:left-[42%] top-[40%] z-50' />

        {/* Top Ellipses */}
        <Elipsis
          className='absolute w-[50%] h-[50%] top-0 left-0 z-40'
          style={
            {
              rotate: '270deg',
              color: getColor(valueTl),
              '--stroke-color': 'var(--joy-palette-primary-offWhite)',
              '--stroke-width': '1'
            } as React.CSSProperties
          }
        />
        <Elipsis
          className='absolute w-[50%] h-[50%] top-0 right-0 z-40'
          style={
            {
              rotate: '0deg',
              color: getColor(valueTr),
              '--stroke-color': 'var(--joy-palette-primary-offWhite)',
              '--stroke-width': '1'
            } as React.CSSProperties
          }
        />

        {/* Bottom Ellipses */}
        <Elipsis
          className='absolute w-[50%] h-[50%] bottom-0 left-0 z-40'
          style={
            {
              rotate: '180deg',
              color: getColor(valueBl),
              '--stroke-color': 'var(--joy-palette-primary-offWhite)',
              '--stroke-width': '1'
            } as React.CSSProperties
          }
        />
        <Elipsis
          className='absolute w-[50%] h-[50%] bottom-0 right-0 z-40'
          style={
            {
              rotate: '90deg',
              color: getColor(valueBr),
              '--stroke-color': 'var(--joy-palette-primary-offWhite)',
              '--stroke-width': '1'
            } as React.CSSProperties
          }
        />
        <Box
          className='w-full h-full flex flex-col items-center justify-center rounded-2xl p-1'
          sx={{
            bgcolor: 'background.level1',
            opacity: 0.6
          }}
        />
      </Box>
    </Box>
  );
};

export default Thurst;
